module.exports = __webpack_public_path__ + "static/media/menu.0cd4b6df.svg";